import type { GeoPoint } from "../broadcast/useLocation";

export async function uploadEmergencyReport(opts: {
  gatewayUrl: string;
  caseId: string;
  photo: Blob;
  location?: GeoPoint | null;
  device?: Record<string, string | number | boolean | null | undefined>;
  landmark?: string;
  note?: string;
}) {
  const headers: Record<string, string> = {
    "Content-Type": opts.photo.type || "application/octet-stream",
    "X-Case-Id": opts.caseId,
  };
  if (opts.location) {
    headers["X-Geo-Lat"] = opts.location.lat.toFixed(6);
    headers["X-Geo-Lon"] = opts.location.lon.toFixed(6);
    headers["X-Geo-Accuracy-M"] = opts.location.accuracyM.toFixed(1);
    headers["X-Geo-At"] = String(opts.location.at);
  }
  if (opts.device) {
    for (const [key, value] of Object.entries(opts.device)) {
      if (value === undefined) continue;
      const headerName = `X-Device-${key}`;
      headers[headerName] = String(value);
    }
  }
  if (opts.landmark?.trim()) headers["X-Report-Landmark"] = opts.landmark.trim();
  if (opts.note) headers["X-Report-Note"] = opts.note;

  const res = await fetch(`${opts.gatewayUrl.replace(/\/$/, "")}/emergency/report`, {
    method: "POST",
    headers,
    body: opts.photo,
  });

  if (!res.ok) {
    throw new Error(`Emergency upload failed (${res.status}): ${await res.text()}`);
  }

  return res.json() as Promise<{
    ok: true;
    reportId: string;
    caseId: string;
    imageKey: string;
    metadataKey: string;
    location: GeoPoint | null;
  }>;
}
